import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DataSource, Not, Repository } from "typeorm";
import { BudgetCostReq, CommonResponseModel } from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { PlantsEntity } from "./plants.entity";
import { PlantsDto } from "./plants.dto";
import { PlantIdReq } from "./plant-id.req";

@Injectable()
export class PlantsService {
    constructor(
        @InjectRepository(PlantsEntity)

        private repo: Repository<PlantsEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createPlant(req: PlantsDto): Promise<CommonResponseModel> {

        try {

            const existingPlant = await this.repo.findOne({ where: { plantName: req.plantName, plantCode: req.plantCode } });
            if (existingPlant) {
                return new CommonResponseModel(false, 0, 'Plant already exists');
            }

            const entity = new PlantsEntity()
            entity.plantCode = req.plantCode;
            entity.plantName = req.plantName;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;


            if (req.plantId) {

                entity.updatedUser = req.createdUser

            } else {

                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in plant creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllPlants(): Promise<CommonResponseModel> {
        const data = await this.repo.find({order:{plantName:'ASC'}})

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    } catch(err) {
        return err;
    }

    async getActiveAllPlants(): Promise<CommonResponseModel> {
        try
        {
            const data = await this.repo.find({
                where: {
                    isActive: true
                }
            })
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
            }
            else{
                return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
            }
        }   
        catch(err) {
            return err;
        }
    }


    async updatePlant(req: PlantsDto): Promise<CommonResponseModel> {
        try {

            const existingBudget = await this.repo.findOne({
                where: {
                    plantCode: req.plantCode,
                    plantName: req.plantName,
                    plantId: Not(req.plantId),
                },
            });

            if (existingBudget) {
                return new CommonResponseModel(false, 0, 'Plant Name already exists');
            }
            let Product = await this.repo.update(
                { plantId: req.plantId },
                {
                    plantCode: req.plantCode,
                    plantName: req.plantName,
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivatePlant(req: PlantsDto): Promise<CommonResponseModel> {
        try {
            const Exists = await this.repo.findOne({ where: { plantId: req.plantId } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current plant information.Refresh and try again');
                } else {
                    const update = await this.repo.update(
                        { plantId: req.plantId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Plant is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Plant is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Plant is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Plant is already  activated');
                        }
                    }
                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getPlantById(req:PlantIdReq): Promise<CommonResponseModel> {
        try
        {
            const data = await this.repo.find({
                where: {
                    plantId: req.plantId
                }
            })
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
            }
            else{
                return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
            }
        }   
        catch(err) {
            return err;
        }
    }
}